import { createFileRoute } from "@tanstack/react-router";

import VenueSettings from "@/components/VenueSettings/VenueSettings";

export const Route = createFileRoute("/gym/$venueUuid/settings")({
  component: VenueSettings,
});
